import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { queryKeys } from "./queryKeys.ts";

export const useInvalidateCardErrorsCache = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: queryKeys.cardErrors() });
  }, [queryClient]);
};
